/**
 * HOOK: useBallSession
 *
 * RESPONSIBILITY:
 * - Orchestrate session-level API flows
 *
 * MUST NEVER:
 * - Render UI
 * - Store state directly
 */

import { loadSession, initialiseSession } from "../api/ballbyball.api";
import { useScoringStore } from "../store/scoring.store";

export async function loadBallSession(matchId) {
  let res;
  try {
    res = await loadSession(matchId);
  } catch (err) {
    const status = err?.response?.status;
    if (status === 409) {
      // No active innings, try to initialize a new session
      await initialiseSession(matchId);
      res = await loadSession(matchId);
    } else {
      throw err;
    }
  }

  useScoringStore.setState({
    aggregate: res.data.aggregate,
    battingStats: res.data.batting_stats,
    bowlingStats: res.data.bowling_stats,
    actions: res.data.actions,
    events: res.data.events,
    matchEnded: Boolean(res.data.match_ended),
    matchTitle: res.data.match_title || "",
    battingTeamName: res.data.batting_team_name || "",
    bowlingTeamName: res.data.bowling_team_name || "",
    battingTeamId: res.data.batting_team_id ?? null,
    bowlingTeamId: res.data.bowling_team_id ?? null,
    inningsId: res.data.innings_id ?? null,
    currentInningsNumber: res.data.current_innings_number ?? null,
    players: res.data.players,
    umpires: res.data.umpires || [],
    // Server-derived Test day/session/overs-today. null on limited overs.
    testState: res.data.test_state ?? null,
    // 2026-06-05 — Super Over context. is_super_over + super_over_index
    // drive UI badges; super_over_eligibility carries the cross-SO
    // batter / bowler exclusion lists that the picker filters use.
    isSuperOver: Boolean(res.data.is_super_over),
    superOverIndex: res.data.super_over_index ?? null,
    superOverEligibility: res.data.super_over_eligibility ?? null,
    // 2026-06-10 — bowling-end context (innings + stadium). Drives the
    // pre-1st-ball end picker modal + the current-end chip.
    firstOverBowlingEnd: res.data.first_over_bowling_end ?? "",
    stadiumEndAName: res.data.stadium_end_a_name ?? "",
    stadiumEndBName: res.data.stadium_end_b_name ?? "",
  });
  return res.data;
}
